module.exports = __webpack_public_path__ + "static/img/3.5a87b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/3.jpg
// module id = qYeS
// module chunks = 5